import { useAuth } from '../context/AuthContext';
import './css/NoRole.css';

const NoRole = () => {
  const { user, logout } = useAuth();

  return (
    <div className="no-role-container">
      <div className="no-role-card">
        <div className="no-role-icon">🔒</div>
        <h1>Dostęp oczekuje na zatwierdzenie</h1>
        <p className="no-role-message">
          Dzień dobry! <strong>{user?.full_name}</strong>,
        </p>
        <p className="no-role-message">
          Twoje konto zostało utworzone, ale nie masz jeszcze nadanych uprawnień. 
        </p>
        <p className="no-role-instruction">
          Jeśli przydzielenie dostępu potrwa dłużej niż 2-3h to proszę o kontakt - aberdowski@matpast.pl.
        </p>
        <div className="no-role-info">
          <p><strong>Twój email:</strong> {user?.email}</p>
          <p><strong>Dział:</strong> {user?.department || 'Nie przypisano'}</p>
        </div>
        <button className="btn btn-primary logout-btn" onClick={logout}>
          Wyloguj się
        </button>
      </div>
    </div>
  );
};

export default NoRole;
